import React from 'react';
import { render, screen } from '@testing-library/react';
import ViewUI from '../ViewUI';
import { __ } from '../../../../i18n';

describe('Chats ViewUI', () => {
  describe('given chats screen header', () => {
    it('should render header title', () => {
      render(<ViewUI />);
      const title = screen.getByText(__('Chats'));
      expect(title).toBeVisible();
    });
  });
});
